export default __webpack_public_path__ + "static/bookademo-05a7dd3f4b84bd22265277be3f07704c.png";